import React from 'react';

export function PrimaryButton({ children, loading, className = '', testId, ...props }) {
    return (
        <button
            data-testid={testId}
            disabled={loading || props.disabled}
            className={`w-full h-14 bg-brand text-white rounded-full font-bold text-base flex items-center justify-center gap-2 shadow-brand-cta hover:bg-brand-dark active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
            {...props}
        >
            {loading ? <span className="inline-block w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" /> : children}
        </button>
    );
}

export function SecondaryButton({ children, className = '', testId, ...props }) {
    return (
        <button
            data-testid={testId}
            className={`w-full h-14 bg-white border border-gray-200 text-brand-navy rounded-full font-bold text-base flex items-center justify-center gap-2 hover:bg-gray-50 active:scale-[0.98] transition-all ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}

export function OutlineButton({ children, className = '', testId, ...props }) {
    return (
        <button
            data-testid={testId}
            className={`w-full h-12 bg-transparent border border-white/40 text-white rounded-full font-semibold text-base flex items-center justify-center gap-2 hover:bg-white/10 active:scale-[0.98] transition-all ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}

export function TextLink({ children, className = '', testId, ...props }) {
    return (
        <button data-testid={testId} className={`text-brand font-semibold hover:underline ${className}`} {...props}>
            {children}
        </button>
    );
}
